export default __webpack_public_path__ + "static/media/minimize-sidebar-icon.229daf04.png";